export default {
  Title: 'Caregivers',
  Action: 'Create new caregiver',
  CaregiverStatus: 'Caregiver status: ',
  Clients: 'Clients: ',
  DefaultName: 'Caregiver',
  Client: 'Clients: #{names}',
  Languages: {
    Extra: '+#{count}',
  },
  YearsExperience: '• #{count} year of experience',
  Filter: {
    Status: 'Status',
  },
  YearsOfExperience: '#{years} Yrs #{months} Months of experience',
  CreatedAt: 'Created on #{date}',
};
